import HttpFactory from '@/mixins/http.factory';
import HtmlEditor from '@/components/Inputs/HtmlEditor'
export default {
	name:'work-item-log',
	mixins:[HttpFactory],
	data () {
		return {
			data:null,
			editorObj:null,
			linkedWorkItem:{attachments:[]},
			notifyData:{commentText:null,attachments:[],files:[]},
			workItemLog:{workItem:null,comments:null,show:false,showNoComments:false},
			zendeskInfo: { credentials: null, user: null, ticket: null, origin: null, app_guid: null, attachments: [], linkedItems: [] },
			showForm:true
		}
	},
	created(){
		this.init();
	},
	components:{HtmlEditor},
	methods:{
		init(){
			let _self=this;
			modalClient = ZAFClient.init();
			parentClient=null;
			//var count=0;
			var triggerInstance=`work-item-log-dialog_zd${this.$route.query.hdTicketId}_wd${this.$route.query.workItemId}`
			modalClient.on(triggerInstance, (data) => {
				if (data.ticket.id == _self.$route.params.zdTicketId) {
					parentClient = modalClient.instance(data.parentClientGuid)
					_self.zendeskInfo = data;
					_self.linkedWorkItem = data.linkData;
					_self.workItemLogFn(true);
					setTimeout(function(){_self.initDropzone(data);},500);
				}
				// _self.zendeskInfo=data;
				// _self.linkedWorkItem=data.linkData;
				// count++;
				// if(count==1){
				// 	_self.workItemLogFn(true);
				// 	setTimeout(function(){_self.initDropzone(data);},500);
				// }
			});
			setTimeout(function(){_self.fn().createHtmlEditor('editor');},1000);
		},
		workItemLogFn(isInit){
			let _self=this;
			let linkData=_self.linkedWorkItem;
			_self.notifyData.hdTicketId = linkData.hdTicketId;
			_self.notifyData.devOpsTenant=linkData.devOpsTenant;
			//_self.notifyData.workItemId=linkData.workItemId;
			let data=linkData;
			data.auth=_self.zendeskInfo.credentials;
			var url = `zendesk/showLog/${linkData.hdTicketId}/${encodeURIComponent(linkData.workItemId)}`;
			_self.post(url,data).then(response=>{
				_self.fn().showLoader(false);
				let workItemLog = response.data.Data;
				if (workItemLog.workItem) {
					_self.notifyData.workItemId = workItemLog.workItem.id;
					_self.notifyData.projectId = workItemLog.workItem.fields['System.TeamProject'];
				}
				workItemLog.showNoComments=false;
				if(!workItemLog.comments || !workItemLog.comments.comments || workItemLog.comments.comments.length<=0){
					workItemLog.showNoComments=true;
				}
				_self.workItemLog=workItemLog;
				
			}).catch(error=>{
				_self.commonErrorMsgDisp(error);
			});
		},
		initDropzone(data){
			const _self=this;
			if (!data || !data.userInfo || !data.userInfo.uploadFiles) return;
			data.credentials.devOpsTenant = _self.linkedWorkItem.devOpsTenant;
			_self.fn().initDropzone('div.dropzone',data.credentials,'devops',function(error,response){
				_self.fn().clearMessage();
				if(error){
					_self.userMsg={show:true,type:'danger',list:[response?response:error]}
					return;
				}
				_self.notifyData.files=_self.notifyData.files.concat(response);
			});
		},
		removeFile(file){
			const _self=this;
			_self.notifyData.files=_self.notifyData.files.filter(d=>d.id!=file.id);
		},
		notifyWorkItemFn(){
			let _self=this;
			_self.fn().clearMessage();
			let data=_self.notifyData;
			if(_self.editorObj)
            	data.commentText=_self.fn().getHtmlEditorContent();
            
			if(!data.commentText || data.commentText.trim()==''){
				_self.userMsg={show:true,type:'danger',list:[`Please enter the comment description`]}
				return;
			}
			data.auth=_self.zendeskInfo.credentials;
			data.user=_self.zendeskInfo.user;
			data.hdTicketId = _self.zendeskInfo.ticket.id;
			if (!_self.linkedWorkItem.workItemUrl) { data.workItemIds = [{ id:data.workItemId,projectId:data.projectId,devOpsTenant:data.devOpsTenant }]; }//temp for the parent/child log screen
			let url=`zendesk/notifylinked/${data.hdTicketId}/${data.workItemId}`
			_self.post(url,data).then(response=>{
				_self.fn().showLoader(false);
				if(response.data.Success){
					_self.notifyData.attachments=[];
					_self.notifyData.files = [];
					_self.notifyData.commentText = null;
					_self.workItemLogFn();
					let userMsg={show:true,type:'info',list:[response.data.Data?response.data.Data:`Workitem: #${data.workItemId} notified Successfully`]}
					_self.userMsg=userMsg;
					_self.fn().clearHtmlEditorContent();
					_self.showForm = false;
					setTimeout(function () { _self.showForm = true }, 500);
					//_self.sendDataToParent(response.data);
				}
				_self.data=response.data.Data;
			}).catch(error=>{
				_self.fn().showLoader(false);
				_self.commonErrorMsgDisp(error);
			});
		},
		htmlEditorChange(data){
			const _self=this;
			_self.notifyData.commentText=data.htmlContent?data.htmlContent:null;
		},
		closeDialog(){
			modalClient.invoke('destroy');
		},
		sendDataToParent(data){
			parentClient.trigger('receive_data_from_modal', data)
      		modalClient.invoke('destroy');

		}
	}
}

